import { Routes } from '@angular/router';
import { PagesComponent } from './pages/pages.component';
import { rootRedirectGuard } from './guards/root-redirect.guard';

export const routes: Routes = [
  // --- LAZY ROUTES ---
  {
    path: '',
    loadChildren: () => import('./pages/pages.routes').then(m => m.PAGES)
  },

  // --- AUTH ROUTES ---
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routes').then(m => m.AUTH)
  },

  // --- WILDCARD ---
  { path: '**', redirectTo: '/', pathMatch: 'full' }
];